import { NgModule } from "@angular/core";
import { CoreModule } from "../core/core.module";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../pipes/pipes.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApplicationElementsModule } from "./application/application-elements.module";
import { IssueElementsModule } from "./issue/issue-elements.module";
import { SharedElementsModule } from "./shared/shared-elements.module";
import { SymbolElementsModule } from "./symbol/symbol-elements.module";
import { UserElementsModule } from "./user/user-elements.module";
import { OrganizationElementsModule } from "./organization/organization-elements.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        PipesModule,
        ApplicationElementsModule,
        IssueElementsModule,
        SharedElementsModule,
        SymbolElementsModule,
        UserElementsModule,
        OrganizationElementsModule
    ],
    declarations: [],
    exports: [
        ApplicationElementsModule,
        IssueElementsModule,
        SharedElementsModule,
        SymbolElementsModule,
        UserElementsModule,
        OrganizationElementsModule
    ]
})
export class ElementsModule {}
